// ===================================================
// CUSTOM GIN
// ===================================================

$(window).load(function(){
  $('.exp__dd-btn').click(function() {
    $('.exp__quant-add-button').trigger('click');
    
  });
  $('.exp__quant-add-button').trigger('click');
});


function calculateMinHeightNew(){
	var infoWrapper 		= $('.Product__Info').outerHeight();
  
  	$('.Product__Wrapper').css('min-height', infoWrapper + 'px');
  	
}


var customerData;

  $('.custom-gin #customerList').hide();

  $.get( "https://sheets.googleapis.com/v4/spreadsheets/1v87WsDVwGBOi2RXOazUoz88Zbo9GPXD5kAkN0mOXFZA/values/Sheet?key=AIzaSyAuUZqKdk9e5p6xRs0tKkrI8G2w8RePWvM", function( data ) {
  		  
    customerData = data;
    
  $('.custom-gin #customerList').show();
  $('.custom-gin #loading').hide();

});

$('#customerList').submit(function(e){
  e.preventDefault();
  displayCustomer($('.custom-gin #customerSelect').val());
  calculateMinHeightNew();
});

$('#landingRecipe').submit(function(e){
  e.preventDefault();
  storeCustomer($('#customerSelect').val());
  Cookies.set('tried-form', true);
  location.href = "https://the-distillery-london.myshopify.com/products/custom-gin";
});

function displayCustomer(code){

    $('.ingredients').remove();
  	$('#infiniteoptions-container').html('<div id="infiniteoptions-container"><div><label for="Name-0-0" class="spb-productdescfont spb-productdesctextcolor">Name</label><span><input type="text" name="properties[Name]" id="Name-0-0" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Date Created-0-1" class="spb-productdescfont spb-productdesctextcolor">Date Created</label><span><input type="text" name="properties[Date Created]" id="Date Created-0-1" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 1-0-2" class="spb-productdescfont spb-productdesctextcolor">Ingredient 1</label><span><input type="text" name="properties[Ingredient 1]" id="Ingredient 1-0-2" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 2-0-3" class="spb-productdescfont spb-productdesctextcolor">Ingredient 2</label><span><input type="text" name="properties[Ingredient 2]" id="Ingredient 2-0-3" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 3-0-4" class="spb-productdescfont spb-productdesctextcolor">Ingredient 3</label><span><input type="text" name="properties[Ingredient 3]" id="Ingredient 3-0-4" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 4-0-5" class="spb-productdescfont spb-productdesctextcolor">Ingredient 4</label><span><input type="text" name="properties[Ingredient 4]" id="Ingredient 4-0-5" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 5-0-6" class="spb-productdescfont spb-productdesctextcolor">Ingredient 5</label><span><input type="text" name="properties[Ingredient 5]" id="Ingredient 5-0-6" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 6-0-7" class="spb-productdescfont spb-productdesctextcolor">Ingredient 6</label><span><input type="text" name="properties[Ingredient 6]" id="Ingredient 6-0-7" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 7-0-8" class="spb-productdescfont spb-productdesctextcolor">Ingredient 7</label><span><input type="text" name="properties[Ingredient 7]" id="Ingredient 7-0-8" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 8-0-9" class="spb-productdescfont spb-productdesctextcolor">Ingredient 8</label><span><input type="text" name="properties[Ingredient 8]" id="Ingredient 8-0-9" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 9-0-10" class="spb-productdescfont spb-productdesctextcolor">Ingredient 9</label><span><input type="text" name="properties[Ingredient 9]" id="Ingredient 9-0-10" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 10-0-11" class="spb-productdescfont spb-productdesctextcolor">Ingredient 10</label><span><input type="text" name="properties[Ingredient 10]" id="Ingredient 10-0-11" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 11-0-12" class="spb-productdescfont spb-productdesctextcolor">Ingredient 11</label><span><input type="text" name="properties[Ingredient 11]" id="Ingredient 11-0-12" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 12-0-13" class="spb-productdescfont spb-productdesctextcolor">Ingredient 12</label><span><input type="text" name="properties[Ingredient 12]" id="Ingredient 12-0-13" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 13-0-14" class="spb-productdescfont spb-productdesctextcolor">Ingredient 13</label><span><input type="text" name="properties[Ingredient 13]" id="Ingredient 13-0-14" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 14-0-15" class="spb-productdescfont spb-productdesctextcolor">Ingredient 14</label><span><input type="text" name="properties[Ingredient 14]" id="Ingredient 14-0-15" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 15-0-16" class="spb-productdescfont spb-productdesctextcolor">Ingredient 15</label><span><input type="text" name="properties[Ingredient 15]" id="Ingredient 15-0-16" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 16-0-17" class="spb-productdescfont spb-productdesctextcolor">Ingredient 16</label><span><input type="text" name="properties[Ingredient 16]" id="Ingredient 16-0-17" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Ingredient 17-0-18" class="spb-productdescfont spb-productdesctextcolor">Ingredient 17</label><span><input type="text" name="properties[Ingredient 17]" id="Ingredient 17-0-18" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Recipe Code-0-19" class="spb-productdescfont spb-productdesctextcolor">Recipe Code</label><span><input type="text" name="properties[Recipe Code]" id="Recipe Code-0-19" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground" required=""></span></div></div>')
    $('#infiniteoptions-container').after('<div class="ingredients white pad-xs-30" id="not-found"><h5>Sorry, your number wasn’t recognised or is still being processed.</h5><p> Please email <a href="mailto:info@theginstitute.com">info@theginstitute.com</a> and we’ll be happy to handle your order directly.</div>');

    for(i=0;i<customerData.values.length;i++) {
    var customer = customerData.values[i];
    
      if(customer[1] == code){
        
        var uniqueNumber  = customer[1]; // Unique Blend Number

        var dateVisited   = customer[2]; // Date Visited
        
        var firstName     = customer[3]; // First Name
        var lastName      = customer[4]; // Last Name
    
        var recipe21 = customer[7];  // Ingredient 1 Name
        var recipe22 = customer[8];  // Ingredient 1 Value
        var recipe23 = customer[9];  // Ingredient 2 Name
        var recipe24 = customer[10]; // Ingredient 2 Value
        var recipe25 = customer[11]; // Ingredient 3 Name
        var recipe26 = customer[12]; // Ingredient 3 Value
        var recipe27 = customer[13]; // Ingredient 4 Name
        var recipe28 = customer[14]; // Ingredient 4 Value
        var recipe29 = customer[15]; // Ingredient 5 Name
        var recipe30 = customer[16]; // Ingredient 5 Value
        
        var recipe32 = customer[17]; // Ingredient 6 Name
        var recipe33 = customer[18]; // Ingredient 6 Value
        var recipe34 = customer[19]; // Ingredient 7 Name
        var recipe35 = customer[20]; // Ingredient 7 Value
        var recipe36 = customer[21]; // Ingredient 8 Name
        var recipe37 = customer[22]; // Ingredient 8 Value
        var recipe38 = customer[23]; // Ingredient 9 Name
        var recipe39 = customer[24]; // Ingredient 9 Value
        var recipe40 = customer[25]; // Ingredient 10 Name
        var recipe41 = customer[26]; // Ingredient 10 Value
        
        var recipe43 = customer[27]; // Ingredient 11 Name
        var recipe44 = customer[28]; // Ingredient 11 Value
        var recipe45 = customer[29]; // Ingredient 12 Name
        var recipe46 = customer[30]; // Ingredient 12 Value
        var recipe47 = customer[31]; // Ingredient 13 Name
        var recipe48 = customer[32]; // Ingredient 13 Value
        var recipe49 = customer[33]; // Ingredient 14 Name
        var recipe50 = customer[34]; // Ingredient 14 Value

        var recipe54 = customer[35]; // Ingredient 15 Name
        var recipe55 = customer[36]; // Ingredient 15 Value
        var recipe56 = customer[37]; // Ingredient 16 Name
        var recipe57 = customer[38]; // Ingredient 16 Value
        var recipe58 = customer[39]; // Ingredient 17 Name
        var recipe59 = customer[40]; // Ingredient 17 Value

        $('.ingredients').remove();
        $('#infiniteoptions-container').after('<div class="ingredients box-shadow white pad-xs-30"><div id="ingredients-name"></div><div id="ingredients-details"></div></div>');
        $('#ingredients').find('p').remove();
        $('[name="properties[Name]"]').val(firstName + ' ' + lastName);
        $('#ingredients-name').append('<h5>' + firstName + ' ' + lastName + '</h5>');
        $('[name="properties[Date Created]"]').val(dateVisited);
        $('#ingredients-name').append('<p>' + dateVisited + '</p>');
        $('[name="properties[Recipe Code]"]').val(uniqueNumber);

        if (recipe21) {
          $('[name="properties[Ingredient 1]"]').val(recipe22 + '%');
          $('[name="properties[Ingredient 1]"]').attr( 'name', 'properties[' + recipe21 + ']');
          $('#ingredients-details').append('<p>' + recipe21 + '<span>' + recipe22 + '%</span></p>');
        }
        if (recipe23) {
          $('[name="properties[Ingredient 2]"]').val(recipe24 + '%');
          $('[name="properties[Ingredient 2]"]').attr( 'name', 'properties[' + recipe23 + ']');
          $('#ingredients-details').append('<p>' + recipe23 + '<span>' + recipe24 + '%</span></p>');
        }
        if (recipe25) {
          $('[name="properties[Ingredient 3]"]').val(recipe26 + '%');
          $('[name="properties[Ingredient 3]"]').attr( 'name', 'properties[' + recipe25 + ']');
          $('#ingredients-details').append('<p>' + recipe25 + '<span>' + recipe26 + '%</span></p>');
        }
        if (recipe27) {
          $('[name="properties[Ingredient 4]"]').val(recipe28 + '%');
          $('[name="properties[Ingredient 4]"]').attr( 'name', 'properties[' + recipe27 + ']');
          $('#ingredients-details').append('<p>' + recipe27 + '<span>' + recipe28 + '%</span></p>');
        }
        if (recipe29) {
          $('[name="properties[Ingredient 5]"]').val(recipe30 + '%');
          $('[name="properties[Ingredient 5]"]').attr( 'name', 'properties[' + recipe29 + ']');
          $('#ingredients-details').append('<p>' + recipe29 + '<span>' + recipe30 + '%</span></p>');
        }
        if (recipe32) {
          $('[name="properties[Ingredient 6]"]').val(recipe33 + '%');
          $('[name="properties[Ingredient 6]"]').attr( 'name', 'properties[' + recipe32 + ']');
          $('#ingredients-details').append('<p>' + recipe32 + '<span>' + recipe33 + '%</span></p>');
        }
        if (recipe34) {
          $('[name="properties[Ingredient 7]"]').val(recipe35 + '%');
          $('[name="properties[Ingredient 7]"]').attr( 'name', 'properties[' + recipe34 + ']');
          $('#ingredients-details').append('<p>' + recipe34 + '<span>' + recipe35 + '%</span></p>');
        }
        if (recipe36) {
          $('[name="properties[Ingredient 8]"]').val(recipe37 + '%');
          $('[name="properties[Ingredient 8]"]').attr( 'name', 'properties[' + recipe36 + ']');
          $('#ingredients-details').append('<p>' + recipe36 + '<span>' + recipe37 + '%</span></p>');
        }
        if (recipe38) {
          $('[name="properties[Ingredient 9]"]').val(recipe39 + '%');
          $('[name="properties[Ingredient 9]"]').attr( 'name', 'properties[' + recipe38 + ']');
          $('#ingredients-details').append('<p>' + recipe38 + '<span>' + recipe39 + '%</span></p>');
        }
        if (recipe40) {
          $('[name="properties[Ingredient 10]"]').val(recipe41 + '%');
          $('[name="properties[Ingredient 10]"]').attr( 'name', 'properties[' + recipe40 + ']');
          $('#ingredients-details').append('<p>' + recipe40 + '<span>' + recipe41 + '%</span></p>');
        }
        if (recipe43) {
          $('[name="properties[Ingredient 11]"]').val(recipe44 + '%');
          $('[name="properties[Ingredient 11]"]').attr( 'name', 'properties[' + recipe43 + ']');
          $('#ingredients-details').append('<p>' + recipe43 + '<span>' + recipe44 + '%</span></p>');
        }
        if (recipe45) {
          $('[name="properties[Ingredient 12]"]').val(recipe46 + '%');
          $('[name="properties[Ingredient 12]"]').attr( 'name', 'properties[' + recipe45 + ']');
          $('#ingredients-details').append('<p>' + recipe45 + '<span>' + recipe46 + '%</span></p>');
        }
        if (recipe47) {
          $('[name="properties[Ingredient 13]"]').val(recipe48 + '%');
          $('[name="properties[Ingredient 13]"]').attr( 'name', 'properties[' + recipe47 + ']');
          $('#ingredients-details').append('<p>' + recipe47 + '<span>' + recipe48 + '%</span></p>');
        }
        if (recipe49) {
          $('[name="properties[Ingredient 14]"]').val(recipe50 + '%');
          $('[name="properties[Ingredient 14]"]').attr( 'name', 'properties[' + recipe49 + ']');
          $('#ingredients-details').append('<p>' + recipe49 + '<span>' + recipe50 + '%</span></p>');
        }
        if (recipe54) {
          $('[name="properties[Ingredient 15]"]').val(recipe55 + '%');
          $('[name="properties[Ingredient 15]"]').attr( 'name', 'properties[' + recipe54 + ']');
          $('#ingredients-details').append('<p>' + recipe54 + '<span>' + recipe55 + '%</span></p>');
        }
        if (recipe56) {
          $('[name="properties[Ingredient 16]"]').val(recipe57 + '%');
          $('[name="properties[Ingredient 16]"]').attr( 'name', 'properties[' + recipe56 + ']');
          $('#ingredients-details').append('<p>' + recipe56 + '<span>' + recipe57 + '%</span></p>');
        }
        if (recipe58) {
          $('[name="properties[Ingredient 17]"]').val(recipe59 + '%');
          $('[name="properties[Ingredient 17]"]').attr( 'name', 'properties[' + recipe58 + ']');
          $('#ingredients-details').append('<p>' + recipe58 + '<span>' + recipe59 + '%</span></p>');
        }
        $('#display-ingredients').show();

        $('form.ProductForm').removeClass('customProduct');
      }  

  }
  
}

function storeCustomer(code){

  for(i=0;i<customerData.values.length;i++){
    var customer = customerData.values[i];
    if(customer[1] == code){
      
      Cookies.set('uniqueNumber', customer[1]);  // Unique Number
      
      Cookies.set('dateVisited',  customer[2]);  // Date Visited
      
      Cookies.set('firstName',    customer[3]);  // First Name
      Cookies.set('lastName',     customer[4]);  // Last Name

      Cookies.set('recipe21', customer[7]); // Ingredient 1 Name
      Cookies.set('recipe22', customer[8]); // Ingredient 1 Value
      Cookies.set('recipe23', customer[9]); // Ingredient 2 Name
      Cookies.set('recipe24', customer[10]); // Ingredient 2 Value
      Cookies.set('recipe25', customer[11]); // Ingredient 3 Name
      Cookies.set('recipe26', customer[12]); // Ingredient 3 Value
      Cookies.set('recipe27', customer[13]); // Ingredient 4 Name
      Cookies.set('recipe28', customer[14]); // Ingredient 4 Value
      Cookies.set('recipe29', customer[15]); // Ingredient 5 Name
      Cookies.set('recipe30', customer[16]); // Ingredient 5 Value
      
      Cookies.set('recipe32', customer[17]); // Ingredient 6 Name
      Cookies.set('recipe33', customer[18]); // Ingredient 6 Value
      Cookies.set('recipe34', customer[19]); // Ingredient 7 Name
      Cookies.set('recipe35', customer[20]); // Ingredient 7 Value
      Cookies.set('recipe36', customer[21]); // Ingredient 8 Name
      Cookies.set('recipe37', customer[22]); // Ingredient 8 Value
      Cookies.set('recipe38', customer[23]); // Ingredient 9 Name
      Cookies.set('recipe39', customer[24]); // Ingredient 9 Value
      Cookies.set('recipe40', customer[25]); // Ingredient 10 Name
      Cookies.set('recipe41', customer[26]); // Ingredient 10 Value
      
      Cookies.set('recipe43', customer[27]); // Ingredient 11 Name
      Cookies.set('recipe44', customer[28]); // Ingredient 11 Value
      Cookies.set('recipe45', customer[29]); // Ingredient 12 Name
      Cookies.set('recipe46', customer[30]); // Ingredient 12 Value
      Cookies.set('recipe47', customer[31]); // Ingredient 13 Name
      Cookies.set('recipe48', customer[32]); // Ingredient 13 Value
      Cookies.set('recipe49', customer[33]); // Ingredient 14 Name
      Cookies.set('recipe50', customer[34]); // Ingredient 14 Value

      Cookies.set('recipe54', customer[35]); // Ingredient 15 Name
      Cookies.set('recipe55', customer[36]); // Ingredient 15 Value
      Cookies.set('recipe56', customer[37]); // Ingredient 16 Name
      Cookies.set('recipe57', customer[38]); // Ingredient 16 Value
      Cookies.set('recipe58', customer[39]); // Ingredient 17 Name
      Cookies.set('recipe59', customer[40]); // Ingredient 17 Value
    }
  }
}
$(window).load(function() {
  if (Cookies.get('firstName')) {

    var uniqueNumber = Cookies.get('uniqueNumber');  // Unique Number

    var dateVisited = Cookies.get('dateVisited');   // Date Visited
      
    var firstName = Cookies.get('firstName');       // First Name
    var lastName = Cookies.get('lastName');         // Last Name

    var recipe21 = Cookies.get('recipe21'); // Ingredient 1 Name
    var recipe22 = Cookies.get('recipe22'); // Ingredient 1 Value
    var recipe23 = Cookies.get('recipe23'); // Ingredient 2 Name
    var recipe24 = Cookies.get('recipe24'); // Ingredient 2 Value
    var recipe25 = Cookies.get('recipe25'); // Ingredient 3 Name
    var recipe26 = Cookies.get('recipe26'); // Ingredient 3 Value
    var recipe27 = Cookies.get('recipe27'); // Ingredient 4 Name
    var recipe28 = Cookies.get('recipe28'); // Ingredient 4 Value
    var recipe29 = Cookies.get('recipe29'); // Ingredient 5 Name
    var recipe30 = Cookies.get('recipe30'); // Ingredient 5 Value
    
    var recipe32 = Cookies.get('recipe32'); // Ingredient 6 Name
    var recipe33 = Cookies.get('recipe33'); // Ingredient 6 Value
    var recipe34 = Cookies.get('recipe34'); // Ingredient 7 Name
    var recipe35 = Cookies.get('recipe35'); // Ingredient 7 Value
    var recipe36 = Cookies.get('recipe36'); // Ingredient 8 Name
    var recipe37 = Cookies.get('recipe37'); // Ingredient 8 Value
    var recipe38 = Cookies.get('recipe38'); // Ingredient 9 Name
    var recipe39 = Cookies.get('recipe39'); // Ingredient 9 Value
    var recipe40 = Cookies.get('recipe40'); // Ingredient 10 Name
    var recipe41 = Cookies.get('recipe41'); // Ingredient 10 Value
    
    var recipe43 = Cookies.get('recipe43'); // Ingredient 11 Name
    var recipe44 = Cookies.get('recipe44'); // Ingredient 11 Value
    var recipe45 = Cookies.get('recipe45'); // Ingredient 12 Name
    var recipe46 = Cookies.get('recipe46'); // Ingredient 12 Value
    var recipe47 = Cookies.get('recipe47'); // Ingredient 13 Name
    var recipe48 = Cookies.get('recipe48'); // Ingredient 13 Value
    var recipe49 = Cookies.get('recipe49'); // Ingredient 14 Name
    var recipe50 = Cookies.get('recipe50'); // Ingredient 14 Value

    var recipe54 = Cookies.get('recipe54'); // Ingredient 15 Name
    var recipe55 = Cookies.get('recipe55'); // Ingredient 15 Value
    var recipe56 = Cookies.get('recipe56'); // Ingredient 16 Name
    var recipe57 = Cookies.get('recipe57'); // Ingredient 16 Value
    var recipe58 = Cookies.get('recipe58'); // Ingredient 17 Name
    var recipe59 = Cookies.get('recipe59'); // Ingredient 17 Value

    
    setTimeout(function(){

        $('[name="properties[Name]"]').val(firstName + ' ' + lastName);
        $('[name="properties[Date Created]"]').val(dateVisited);
        $('[name="properties[Recipe Code]"]').val(uniqueNumber);

        $('.ingredients').remove();
        $('#infiniteoptions-container').after('<div class="ingredients box-shadow white pad-xs-30"><div id="ingredients-name"></div><div id="ingredients-details"></div></div>');
        $('#ingredients').find('p').remove();
        $('[name="properties[Name]"]').val(firstName + ' ' + lastName);
        $('#ingredients-name').append('<h5>' + firstName + ' ' + lastName + '</h5>');
        $('[name="properties[Date Created]"]').val(dateVisited);
        $('#ingredients-name').append('<p>' + dateVisited + '</p>');

        if (recipe21) {
          $('[name="properties[Ingredient 1]"]').val(recipe22 + '%');
          $('[name="properties[Ingredient 1]"]').attr( 'name', 'properties[' + recipe21 + ']');
          $('#ingredients-details').append('<p>' + recipe21 + '<span>' + recipe22 + '%</span></p>');
        }
        if (recipe23) {
          $('[name="properties[Ingredient 2]"]').val(recipe24 + '%');
          $('[name="properties[Ingredient 2]"]').attr( 'name', 'properties[' + recipe23 + ']');
          $('#ingredients-details').append('<p>' + recipe23 + '<span>' + recipe24 + '%</span></p>');
        }
        if (recipe25) {
          $('[name="properties[Ingredient 3]"]').val(recipe26 + '%');
          $('[name="properties[Ingredient 3]"]').attr( 'name', 'properties[' + recipe25 + ']');
          $('#ingredients-details').append('<p>' + recipe25 + '<span>' + recipe26 + '%</span></p>');
        }
        if (recipe27) {
          $('[name="properties[Ingredient 4]"]').val(recipe28 + '%');
          $('[name="properties[Ingredient 4]"]').attr( 'name', 'properties[' + recipe27 + ']');
          $('#ingredients-details').append('<p>' + recipe27 + '<span>' + recipe28 + '%</span></p>');
        }
        if (recipe29) {
          $('[name="properties[Ingredient 5]"]').val(recipe30 + '%');
          $('[name="properties[Ingredient 5]"]').attr( 'name', 'properties[' + recipe29 + ']');
          $('#ingredients-details').append('<p>' + recipe29 + '<span>' + recipe30 + '%</span></p>');
        }
        if (recipe32) {
          $('[name="properties[Ingredient 6]"]').val(recipe33 + '%');
          $('[name="properties[Ingredient 6]"]').attr( 'name', 'properties[' + recipe32 + ']');
          $('#ingredients-details').append('<p>' + recipe32 + '<span>' + recipe33 + '%</span></p>');
        }
        if (recipe34) {
          $('[name="properties[Ingredient 7]"]').val(recipe35 + '%');
          $('[name="properties[Ingredient 7]"]').attr( 'name', 'properties[' + recipe34 + ']');
          $('#ingredients-details').append('<p>' + recipe34 + '<span>' + recipe35 + '%</span></p>');
        }
        if (recipe36) {
          $('[name="properties[Ingredient 8]"]').val(recipe37 + '%');
          $('[name="properties[Ingredient 8]"]').attr( 'name', 'properties[' + recipe36 + ']');
          $('#ingredients-details').append('<p>' + recipe36 + '<span>' + recipe37 + '%</span></p>');
        }
        if (recipe38) {
          $('[name="properties[Ingredient 9]"]').val(recipe39 + '%');
          $('[name="properties[Ingredient 9]"]').attr( 'name', 'properties[' + recipe38 + ']');
          $('#ingredients-details').append('<p>' + recipe38 + '<span>' + recipe39 + '%</span></p>');
        }
        if (recipe40) {
          $('[name="properties[Ingredient 10]"]').val(recipe41 + '%');
          $('[name="properties[Ingredient 10]"]').attr( 'name', 'properties[' + recipe40 + ']');
          $('#ingredients-details').append('<p>' + recipe40 + '<span>' + recipe41 + '%</span></p>');
        }
        if (recipe43) {
          $('[name="properties[Ingredient 11]"]').val(recipe44 + '%');
          $('[name="properties[Ingredient 11]"]').attr( 'name', 'properties[' + recipe43 + ']');
          $('#ingredients-details').append('<p>' + recipe43 + '<span>' + recipe44 + '%</span></p>');
        }
        if (recipe45) {
          $('[name="properties[Ingredient 12]"]').val(recipe46 + '%');
          $('[name="properties[Ingredient 12]"]').attr( 'name', 'properties[' + recipe45 + ']');
          $('#ingredients-details').append('<p>' + recipe45 + '<span>' + recipe46 + '%</span></p>');
        }
        if (recipe47) {
          $('[name="properties[Ingredient 13]"]').val(recipe48 + '%');
          $('[name="properties[Ingredient 13]"]').attr( 'name', 'properties[' + recipe47 + ']');
          $('#ingredients-details').append('<p>' + recipe47 + '<span>' + recipe48 + '%</span></p>');
        }
        if (recipe49) {
          $('[name="properties[Ingredient 14]"]').val(recipe50 + '%');
          $('[name="properties[Ingredient 14]"]').attr( 'name', 'properties[' + recipe49 + ']');
          $('#ingredients-details').append('<p>' + recipe49 + '<span>' + recipe50 + '%</span></p>');
        }
        if (recipe54) {
          $('[name="properties[Ingredient 15]"]').val(recipe55 + '%');
          $('[name="properties[Ingredient 15]"]').attr( 'name', 'properties[' + recipe54 + ']');
          $('#ingredients-details').append('<p>' + recipe54 + '<span>' + recipe55 + '%</span></p>');
        }
        if (recipe56) {
          $('[name="properties[Ingredient 16]"]').val(recipe57 + '%');
          $('[name="properties[Ingredient 16]"]').attr( 'name', 'properties[' + recipe56 + ']');
          $('#ingredients-details').append('<p>' + recipe56 + '<span>' + recipe57 + '%</span></p>');
        }
        if (recipe58) {
          $('[name="properties[Ingredient 17]"]').val(recipe59 + '%');
          $('[name="properties[Ingredient 17]"]').attr( 'name', 'properties[' + recipe58 + ']');
          $('#ingredients-details').append('<p>' + recipe58 + '<span>' + recipe59 + '%</span></p>');
        }

    },1000);
    
    Cookies.remove('uniqueNumber');  // Unique Number

    Cookies.remove('dateVisited');  // Date Visited
      
    Cookies.remove('firstName');    // First Name
    Cookies.remove('lastName');     // Last Name

    Cookies.remove('recipe21'); // Ingredient 1 Name
    Cookies.remove('recipe22'); // Ingredient 1 Value
    Cookies.remove('recipe23'); // Ingredient 2 Name
    Cookies.remove('recipe24'); // Ingredient 2 Value
    Cookies.remove('recipe25'); // Ingredient 3 Name
    Cookies.remove('recipe26'); // Ingredient 3 Value
    Cookies.remove('recipe27'); // Ingredient 4 Name
    Cookies.remove('recipe28'); // Ingredient 4 Value
    Cookies.remove('recipe29'); // Ingredient 5 Name
    Cookies.remove('recipe30'); // Ingredient 5 Value
    
    Cookies.remove('recipe32'); // Ingredient 6 Name
    Cookies.remove('recipe33'); // Ingredient 6 Value
    Cookies.remove('recipe34'); // Ingredient 7 Name
    Cookies.remove('recipe35'); // Ingredient 7 Value
    Cookies.remove('recipe36'); // Ingredient 8 Name
    Cookies.remove('recipe37'); // Ingredient 8 Value
    Cookies.remove('recipe38'); // Ingredient 9 Name
    Cookies.remove('recipe39'); // Ingredient 9 Value
    Cookies.remove('recipe40'); // Ingredient 10 Name
    Cookies.remove('recipe41'); // Ingredient 10 Value
    
    Cookies.remove('recipe43'); // Ingredient 11 Name
    Cookies.remove('recipe44'); // Ingredient 11 Value
    Cookies.remove('recipe45'); // Ingredient 12 Name
    Cookies.remove('recipe46'); // Ingredient 12 Value
    Cookies.remove('recipe47'); // Ingredient 13 Name
    Cookies.remove('recipe48'); // Ingredient 13 Value
    Cookies.remove('recipe49'); // Ingredient 14 Name
    Cookies.remove('recipe50'); // Ingredient 14 Value

    Cookies.remove('recipe54'); // Ingredient 15 Name
    Cookies.remove('recipe55'); // Ingredient 16 Value
    Cookies.remove('recipe56'); // Ingredient 17 Name
    Cookies.remove('recipe57'); // Ingredient 18 Value
    Cookies.remove('recipe58'); // Ingredient 19 Name
    Cookies.remove('recipe59'); // Ingredient 20 Value

  } else {
    if (Cookies.get('tried-form', true)) {
      $('.ingredients').remove();
      $('#infiniteoptions-container').after('<div class="ingredients white pad-xs-30" id="not-found"><h5>Sorry, Your number wasn’t recognised or is still being processed.</h5><p> Please email <a href="mailto:info@theginstitute.com">info@theginstitute.com</a> and we’ll be happy to handle your order directly.</div></div>');
    }
  }
});